// Note: this file is separate from ./models/utils.ts to prevent a dependency cycle

import type {PropertyFilter} from './models/property-filter';
import {PropertyType} from './models/types';

export function isEnhancedListFilter(filter: PropertyFilter) {
  return (
    filter.listQuantifier &&
    // lookup table property with join key that is a list
    filter.joinPropertyType === PropertyType.List &&
    // excluding the join key itself (we only support lookup table properties right now)
    Array.isArray(filter.propertyName)
  );
}
